module.exports = __webpack_public_path__ + "cancellara-dist/img/proxima.035e76dc.png";